import Cookies from "js-cookie";
import { useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

import ApprovedRequests from "./ApprovedRequests";
import PendingRequests from "./PendingRequests";
import RejectedRequests from "./RejectedRequests";

const FrymeTab = () => {

  const [searchParams, setSearchParams] = useSearchParams();

  // FETCH EMAIL FROM COOKIES
  const email = Cookies.get("userEmail");

  console.log("Logged User Email:", email);

  const activeTab =
    searchParams.get("tab") || "pendingRequestsFranchise";

  useEffect(() => {

    if (!searchParams.get("tab")) {

      setSearchParams({
        tab: "pendingRequestsFranchise",
      });

    }

  }, [searchParams, setSearchParams]);

  const handleTabChange = (key) => {

    setSearchParams({
      tab: key,
    });

  };

  return (

    <div
      className="scrollable-container"
      style={{ height: "100%" }}
    >

      <div className="header-container">

        <h1>
          <strong>Frymes</strong>
        </h1>

      </div>

      <Tabs
        activeKey={activeTab}
        onSelect={handleTabChange}
        id="franchiseCustomers"
      >

        <Tab
          eventKey="pendingRequestsFranchise"
          title="Pending Requests"
        >
          <PendingRequests email={email} />
        </Tab>

        <Tab
          eventKey="approvedRequestsFranchise"
          title="Approved Requests"
        >
          <ApprovedRequests email={email} />
        </Tab>

        <Tab
          eventKey="rejectedRequestsFranchise"
          title="Rejected Requests"
        >
          <RejectedRequests email={email} />
        </Tab>

      </Tabs>

    </div>
  );
};

export default FrymeTab;